import React, { useMemo } from "react";

const asDate = (value, endOfDay = false) => {
  if (!value) return null;
  const date = new Date(`${value}T${endOfDay ? "23:59:59" : "00:00:00"}`);
  return Number.isNaN(date.getTime()) ? null : date;
};

export default function LeagueInsights({ standings = [], competitions = [], season, movement = {} }) {
  const insights = useMemo(() => {
    const eligible = competitions.filter((item) => item.status === "published" || item.status === "completed");
    const completed = eligible.filter((item) => item.status === "completed");
    const leader = standings[0];
    const runnerUp = standings[1];
    const titleGap = leader && runnerUp ? Number(leader.points || 0) - Number(runnerUp.points || 0) : 0;
    const biggestMover = [...standings].sort((a, b) => Number(movement[b.id] || 0) - Number(movement[a.id] || 0))[0];
    const operationalLeader = [...standings].sort((a, b) => Number(b.points || 0) - Number(a.points || 0))[0];
    const recent = completed.slice(0, 5);
    const winsBySite = recent.reduce((map, item) => {
      const winner = (item.winners || []).find((entry) => Number(entry.place) === 1);
      if (winner?.siteId) map[winner.siteId] = Number(map[winner.siteId] || 0) + 1;
      return map;
    }, {});
    const bestForm = [...standings].sort((a, b) => Number(winsBySite[b.id] || 0) - Number(winsBySite[a.id] || 0))[0];
    const outcomeCompletion = eligible.length ? Math.round((completed.length / eligible.length) * 100) : 0;

    const start = asDate(season?.startDate);
    const end = asDate(season?.endDate, true);
    let seasonProgress = 0;
    if (start && end && end > start) {
      const now = Date.now();
      seasonProgress = now <= start.getTime() ? 0 : now >= end.getTime() ? 100 : Math.round(((now - start.getTime()) / (end.getTime() - start.getTime())) * 100);
    }

    return {
      titleGap,
      biggestMover,
      operationalLeader,
      bestForm,
      bestFormWins: Number(winsBySite[bestForm?.id] || 0),
      outcomeCompletion,
      completed: completed.length,
      eligible: eligible.length,
      seasonProgress,
    };
  }, [standings, competitions, season, movement]);

  return (
    <section className="league-insights-grid">
      <article><span>Outcome completion</span><strong>{insights.outcomeCompletion}%</strong><small>{insights.completed} of {insights.eligible} competitions completed</small></article>
      <article><span>Season progress</span><strong>{insights.seasonProgress}%</strong><small>time elapsed between season dates</small></article>
      <article><span>Title race</span><strong>{insights.titleGap}</strong><small>points separating the top two</small></article>
      <article><span>Biggest climber</span><strong>{insights.biggestMover?.name || "Awaiting data"}</strong><small>{Math.max(0, Number(movement[insights.biggestMover?.id] || 0))} places gained</small></article>
      <article><span>Operational leader</span><strong>{insights.operationalLeader?.name || "Awaiting data"}</strong><small>{Number(insights.operationalLeader?.points || 0)} League points</small></article>
      <article><span>Best form</span><strong>{insights.bestForm?.name || "Awaiting data"}</strong><small>{insights.bestFormWins} wins in the last five competitions</small></article>
    </section>
  );
}
